'use client';

import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Heading } from '@/components/ui/shared/heading';

import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

export default function GeneralPractitioner({ subscriptionInfo }) {
  const history = useHistory();

  const hasPractitionerFullName =
    !!subscriptionInfo?.subscriptionPractitionerName &&
    !!subscriptionInfo?.subscriptionPractitionerSurname;

  const hasPractitionerUrlData =
    !!subscriptionInfo?.subscriptionPractitionerLocalId &&
    !!subscriptionInfo?.subscriptionPractitionerServiceTypeId;

  const generalPractitionerUrl = hasPractitionerUrlData
    ? `/services/1/${subscriptionInfo.subscriptionPractitionerServiceTypeId}?specialistId=${subscriptionInfo.subscriptionPractitionerLocalId}`
    : null;

  if (!hasPractitionerFullName && !hasPractitionerUrlData) return null;

  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
      <div className="flex flex-col gap-y-2">
        <Heading variant="userAccountTitle">Šeimos gydytojas</Heading>
        {hasPractitionerFullName && (
          <Label variant="subheading">
            {`${subscriptionInfo.subscriptionPractitionerName} ${subscriptionInfo.subscriptionPractitionerSurname}`}
          </Label>
        )}
      </div>

      {!!generalPractitionerUrl && (
        <Button
          variant="light"
          onClick={() => {
            history.push(generalPractitionerUrl);
          }}
        >
          Registruotis pas šeimos gydytoją
        </Button>
      )}
    </div>
  );
}
